import Moengage from '@moengage/web-sdk';
import { getViewData } from '../modules/view-data';

export default {
    /**
     * Provide moengage function to the view components.
     *
     * @param {Vue} Vue
     */
    install(Vue) {
        if (typeof window !== 'undefined') {
            Moengage.initialize({
                app_id: getViewData('env.MOENGAGE_APP_ID'),
                cluster: 'DC_2',
                debug_logs: getViewData('env.MOENGAGE_DEBUG_LOGS'),
                useLatest: true,
                swPath: '/service-worker.js',
                webpush: {
                    optin: false,
                },
            });

            Vue.prototype.$moengage = Moengage;
        }
    },
};
